import React from "react";
import Footer from '../components/ui/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8 text-center">Privacy Policy</h1>
        {/* Privacy policy content would go here */}
      </div>
      <Footer />
    </div>
  );
};

export default Privacy;
